import React from 'react'
import { Image, Button } from 'semantic-ui-react'
import ProductList from '../../components/list/product-list'
import ContentLoader from '../../components/content-loader/content-loader'
import styles from '../../components/login/login.module.css'
import img from '../../images/spectro.jpeg'
import { history } from '../../redux/store'

const ProductSelect = () => (
  <div className={styles.authWrapper}>
    <div className={styles.authInner}>
      <Button
        onClick={() => {
          localStorage.clear()
          history.push('/login')
        }}
        // backgroundColor="white"
        style={{
          backgroundColor: 'white',
          color: 'black',
          textDecoration: 'underline',
        }}
        labelPosition="left"
        icon="left chevron"
        content="Sign Out"
      />
      <Image src={img} size="small" className={styles.logo} />
      <ProductList
        size="massive"
        divided
        animated
        verticalAlign="middle"
        style={{ display: 'flex', flexDirection: 'column' }}
      />

      <ContentLoader />
    </div>
  </div>
)

export default ProductSelect
